export default __webpack_public_path__ + "static/media/i.05f64c18.mp4";